module.exports = __FOREMAN_VENDOR__UUID_V_1__;